const countDirectTrips = (trips) => ({
    num: trips?.filter((trip) => trip.transfers === 0)?.length,
});

export { countDirectTrips };
